import { Icon } from '@iconify/react/dist/iconify.js';
import { FormControl, FormHelperText, FormLabel, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';


export default function CustomTextField({ values, variant, onChange, error, placeholder, type, typePw, height, title, required, rows, multiline, InputProps, disabled, subtitle, width, sx, inputSx, max, padding = 1, marginTop, textFieldStyle, paddingTop}) {
    
    const handleOnChange = (e) => {
        const value = e;
        if (type === "number") {
            const filteredValue = value.replace(/[^0-9.]/g, '');
            if (max && parseFloat(filteredValue) > max) return;
            onChange(filteredValue);
        } else if (type === "phone") {
            const filteredValue = value.replace(/[^0-9]/g, '');
            onChange(filteredValue);
        } else {
            onChange(value);
        }
    }

    const defaultStyle = { 
        backgroundColor: disabled ? '#F1F3F4' : "", 
        color: disabled ? '#52525280' : "", 
        marginTop: marginTop || "3px", 
        border: '1.5px solid #E6E6E6', 
        borderRadius: 12, 
        paddingInline: 10, 
        paddingBlock: 3
    };

    return (
        <>
            <FormControl variant={variant || "outlined"} fullWidth={width ? false : true} style={{ width: width && width, paddingTop: paddingTop || "auto" }}>
                {title && <FormLabel style={{ fontFamily: 'SophiaPro', fontWeight: 500, fontSize: 14, margin: 0, color: "#594A4E" }}>{title}</FormLabel>}
                <TextField
                    size="small"
                    placeholder={!disabled ? placeholder: ''}
                    type={typePw}
                    multiline={multiline}
                    rows={rows}
                    InputProps={{
                        ...InputProps,
                        disableUnderline: true,
                    }}
                    required={required}
                    value={values}
                    disabled={disabled}
                    error={error ? true : false}
                    variant={variant || "standard"}
                    sx={{
                        "& .MuiInput-root": {
                            // Bottom border
                            "&:before": {
                                borderColor: "#D9D9D9",
                            },
                            fontFamily: 'SophiaPro'
                        },
                        backgroundColor: 'white',
                        height: height && height,
                        ...(sx || {}), 
                    }}
                    inputProps={
                        {
                            sx: {
                                '&::placeholder': {
                                    color: '#BDBDBD',
                                    opacity: 1, // otherwise firefox shows a lighter color
                                },
                                padding: padding,
                                ...(inputSx || {}),    
                            },
                        }
                    }
                    style={{ ...defaultStyle, ...textFieldStyle }}
                    onChange={(e) => handleOnChange && handleOnChange(e.target.value)}
                />
                {subtitle && <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '400' }}>{subtitle}</span>}
                {error && <FormHelperText className='d-flex align-items-center m-0' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>}
            </FormControl>
        </>
    );
}
